module.exports = __webpack_public_path__ + "img/32.5c803ca5.png";